import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

const params = new URLSearchParams(window.location.search);
const langFromUrl = params.get('lang');

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    lng: langFromUrl || 'zh-TW',
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;